export default "__VITE_ASSET__BMiT$aOb__"